import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/vip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-00e36364"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sider" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px"}
}, null, -1))
const _hoisted_4 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"margin-top":"-20px"}
}
const _hoisted_6 = { class: "hotPost" }
const _hoisted_7 = { class: "hotPostTitle" }

import CheckInButton from "@/components/checkIn/CheckInButton.vue";
import { useLoginUserStore } from "@/store/userStore";
import router from "@/router";
import { ref, watchEffect } from "vue";
import API from "@/api";
import { listPostVoByPageUsingPost } from "@/api/postController";
import message from "@arco-design/web-vue/es/message";
import DatePicker from "@/components/checkIn/DatePicker.vue";
import { listInterviewQuestionVoByPageUsingPost } from "@/request/api/interviewQuestionController";

interface Props {
  bizType: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSider',
  props: {
    bizType: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const loginUser = ref<API.LoginUserVO>(useLoginUserStore().loginUser);

const props = __props;

/**
 * 点击菜单项
 * @param id
 */
const onClickMenuItem = async (url: string) => {
  router.push(url);
};

const dataList = ref<any[]>([]);
const loading = ref(false);
const clickHot = async (id: number) => {
  if (props.bizType == "post") {
    router.push("/post/detail/" + id);
  } else if (props.bizType == "question") {
    router.push("/interviewQuestion/detail/" + id);
  }
};
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  let response: any;
  if (props.bizType == "post") {
    response = await listPostVoByPageUsingPost({
      current: 1,
      pageSize: 5,
      sortField: "thumbNum",
      sortOrder: "descend",
    });
  } else if (props.bizType == "question") {
    response = await listInterviewQuestionVoByPageUsingPost({
      current: 1,
      pageSize: 5,
      sortField: "viewNum",
      sortOrder: "descend",
    });
  }
  if (response.data.code === 0 && response.data.data) {
    dataList.value = response.data.data?.records || [];
    if (dataList.value.length == 0) {
      message.warning("暂无数据");
    }
    dataList.value.forEach((item: any) => {
      if (item.title == undefined || item.title == "" || item.title == null) {
        item.title = item.content;
      }
    });
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});
/**
 * hotPost
 */

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_icon_bookmark = _resolveComponent("icon-bookmark")!
  const _component_icon_book = _resolveComponent("icon-book")!
  const _component_icon_apps = _resolveComponent("icon-apps")!
  const _component_icon_fire = _resolveComponent("icon-fire")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_a_row, { style: {"padding":"20px 0px 0 20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { flex: "auto" }, {
              default: _withCtx(() => [
                (loginUser.value.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_a_space, {
                        size: "large",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickMenuItem('/my/user')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_avatar, {
                            "image-url": loginUser.value.userAvatar
                          }, null, 8, ["image-url"]),
                          _createVNode(_component_a_space, { direction: "vertical" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_typography_text, { style: {"font-size":"16px"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(loginUser.value?.userName ?? "无名"), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_3
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_typography_text, {
                                type: "secondary",
                                class: "des"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(loginUser.value.userProfile), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_a_button, {
                        type: "outline",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickMenuItem('/user/login')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("去登录 ")
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "100px" }, {
              default: _withCtx(() => [
                _createVNode(CheckInButton, { style: {"margin":"15px 10px 10px 10px"} })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider),
        _createVNode(_component_a_row, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 8,
              style: {"display":"grid","justify-items":"center"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickMenuItem('/')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { shape: "circle" }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_icon_bookmark)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 帖子 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 8,
              style: {"display":"grid","justify-items":"center"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickMenuItem('/interview')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { shape: "circle" }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_icon_book)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 题目 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 8,
              style: {"display":"grid","justify-items":"center"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickMenuItem('/app')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { shape: "circle" }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_icon_apps)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 问答 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_unref(useLoginUserStore)().loginUser.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_divider),
            _createVNode(DatePicker)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_typography_text, { style: {"font-size":"18px"} }, {
          default: _withCtx(() => [
            _createTextVNode(" 🔥热门" + _toDisplayString(props.bizType == "question" ? "题目" : "文章"), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_a_list, {
          bordered: false,
          data: dataList.value,
          split: false,
          size: "small",
          loading: loading.value,
          style: {"margin":"5px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (data) => {
              return (_openBlock(), _createBlock(_component_a_list_item, {
                key: data.id,
                class: "action",
                onClick: ($event: any) => (clickHot(data.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_text, {
                            style: {"font-size":"16px","margin":"0"},
                            ellipsis: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.title), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_col, {
                        span: 3,
                        offset: 1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon_fire),
                          _createVNode(_component_a_typography_text, { type: "secondary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.viewNum), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data", "loading"])
      ])
    ])
  ], 64))
}
}

})